var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCadminLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#395FD2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1245_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7021 23.7124C27.0212 23.352 27.2829 22.9888 27.6106 22.6803C28.6169 21.729 29.8071 21.2504 31.1986 21.2619C31.9634 21.2677 32.7166 21.3225 33.4526 21.5358C35.1374 22.023 36.1149 23.1877 36.5835 24.8368C36.9342 26.0735 36.9975 27.3449 37.0004 28.6192C37.0061 31.306 36.9917 33.9958 36.9975 36.6827C36.9975 36.9335 36.9285 36.9998 36.6812 36.9998C35.3012 36.9883 33.9184 36.9883 32.5384 36.9998C32.294 37.0027 32.2422 36.9278 32.2422 36.6971C32.2509 34.14 32.2509 31.5828 32.2422 29.0228C32.2394 28.3828 32.1991 27.7399 32.0209 27.1171C31.6902 25.9697 30.8709 25.3845 29.672 25.4479C28.0332 25.5344 27.1822 26.3474 26.9724 28.0166C26.9235 28.4145 26.8976 28.8152 26.9005 29.2159C26.9034 31.7039 26.8976 34.1919 26.9062 36.6798C26.9062 36.9278 26.8459 36.9998 26.5929 36.9998C25.2014 36.9883 23.8099 36.9883 22.4184 36.9998C22.1941 37.0027 22.1309 36.9422 22.1309 36.7144C22.1366 31.7904 22.1366 26.8635 22.1309 21.9394C22.1309 21.6944 22.2114 21.6396 22.4414 21.6396C23.761 21.6482 25.0835 21.6511 26.4031 21.6396C26.6475 21.6367 26.7079 21.7174 26.705 21.9481C26.6935 22.5333 26.7021 23.1243 26.7021 23.7124Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1349 29.3399C19.1349 31.7759 19.132 34.212 19.1406 36.6481C19.1406 36.9191 19.0745 36.9998 18.7956 36.9969C17.4156 36.9825 16.0356 36.9854 14.6527 36.994C14.4314 36.9969 14.3652 36.9393 14.3652 36.7115C14.371 31.7788 14.371 26.8461 14.3652 21.9106C14.3652 21.7059 14.4141 21.6338 14.6297 21.6338C16.0299 21.6424 17.43 21.6453 18.8301 21.6309C19.1004 21.628 19.1349 21.7318 19.1349 21.9653C19.132 24.4274 19.1349 26.8836 19.1349 29.3399Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5152 16.7503C19.5181 18.2812 18.2789 19.5266 16.7552 19.5266C15.2516 19.5266 14.0038 18.2812 13.9981 16.7734C13.9952 15.2512 15.2429 13.9971 16.7638 14C18.2703 14.0029 19.5152 15.2425 19.5152 16.7503Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1245_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadminLinkedin);
export default __webpack_public_path__ + "static/media/CadminLinkedin.6406d0b6f82ff69b0a2a5b766317f61e.svg";
export { ForwardRef as ReactComponent };